// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"f8aefc91","508":"ee2d104a","569":"ee9b0e6a","683":"a66e441c","811":"f2a7a85f","870":"c16bc106"}[chunkId] + ".chunk.js";
};